import { defineMessages } from "@/i18n";
import en from "./en";

export const panelsNotificationsMessages = defineMessages(
  "panels-notifications",
  en,
);
